import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'users';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const UsersReducer = combineReducers({
    selection: selectionSlice.reducer,
});
